import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m15.8 14.4-7.5-13c0-.1-.2-.2-.3-.2s-.2.1-.2.2l-7.5 13c-.1.2 0 .4.2.4h15c.3 0 .4-.2.3-.4m-14-.6L8 2.9l6.3 10.9zm5.7-7.9v4c0 .3.2.5.5.5s.5-.2.5-.5v-4c0-.3-.2-.5-.5-.5s-.5.2-.5.5m-.5 6c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1" />
  </svg>
);
const SvgExclamationTriangle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="exclamation-triangle" {...props} />;
export default SvgExclamationTriangle;
